import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useClients = () => {
	return useQuery({
		queryKey: ["partner", "clients"],
		queryFn: partnerApiService.listTeams,
	});
};
